
import { z } from "zod";

export const activityTypeOptions = [
  { value: "irrigation", label: "Irrigation" },
  { value: "fertilization", label: "Fertilisation" },
  { value: "weather", label: "Météo" },
  { value: "harvest", label: "Récolte" },
  { value: "planting", label: "Plantation" },
  { value: "maintenance", label: "Maintenance" },
  { value: "inspection", label: "Inspection" },
  { value: "other", label: "Autre" },
];

export const activityPriorityOptions = [
  { value: "low", label: "Basse" },
  { value: "medium", label: "Moyenne" },
  { value: "high", label: "Haute" },
];

export const activityStatusOptions = [
  { value: "upcoming", label: "À venir" },
  { value: "in_progress", label: "En cours" },
  { value: "completed", label: "Terminée" },
  { value: "cancelled", label: "Annulée" },
];

export const reminderTimeOptions = [
  { value: "15min", label: "15 minutes avant" },
  { value: "30min", label: "30 minutes avant" },
  { value: "1hour", label: "1 heure avant" },
  { value: "2hours", label: "2 heures avant" },
  { value: "6hours", label: "6 heures avant" },
  { value: "12hours", label: "12 heures avant" },
  { value: "1day", label: "1 jour avant" },
  { value: "2days", label: "2 jours avant" },
];

export const activitySchema = z.object({
  id: z.string().uuid().optional(),
  title: z.string().min(2, { message: "Le titre doit comporter au moins 2 caractères" }),
  description: z.string().optional(),
  activity_type: z.enum(["irrigation", "fertilization", "weather", "harvest", "planting", "maintenance", "inspection", "other"]),
  scheduled_for: z.date({ required_error: "Veuillez sélectionner une date" }),
  time: z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, { message: "Format d'heure invalide (HH:MM)" }),
  parcel_id: z.string().uuid().optional(),
  priority: z.enum(["low", "medium", "high"]).default("medium"),
  status: z.enum(["upcoming", "in_progress", "completed", "cancelled"]).default("upcoming"),
  reminder_time: z.string().optional(),
});

export type ActivityFormValues = z.infer<typeof activitySchema>;

export type Activity = ActivityFormValues & {
  user_id: string;
  created_at: string;
  updated_at: string;
};
